import { type RootState } from '../../stores/redux';

export const selectCaptions = (state: RootState) => state.captions.captions;
export const selectIsCaptionsOpen = (state: RootState) =>
  state.captions.isCaptionsOpen;
